/* eslint-disable no-restricted-imports */
import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@material-ui/core';
import { dialogContentStyles } from './dialogContentCssDefs';

export type DialogContentProps = MuiDialogContentProps;

/**
 * @deprecated Deprecated — use pantry Modal.Body instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-modal-modal-body--docs
 */
export const DialogContent = (props: DialogContentProps) => {
  return <MuiDialogContent dividers css={dialogContentStyles} {...props} />;
};
